export default __webpack_public_path__ + "static/media/pr_2024.90ae40e4.mp3";